import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 12L11.5 20L11 20L11 15L3 15L3 9L11 9L11 4L11.5 4L21 12Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBoldRight.js.map